import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const historyApi = {
  create (params) {
    // 创建新收听记录
    return axios.post(`${ApiSetting.baseUrl}/api/play_history/`, querystring.stringify(params))
  },
  episode_list (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/play_history/episode_list/`, {params: params})
  },
  clear (params) {
    return axios.delete(
      `${ApiSetting.baseUrl}/api/play_history/clear/`, querystring.stringify(params))
  }
}

export default historyApi
